var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOurServiceRightBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 325,
    viewBox: "0 0 264 325",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M283.861 153.495C317.648 151.985 339.978 125.942 333.735 95.3262C327.493 64.7103 295.043 41.1149 261.256 42.6245C227.468 44.1341 205.139 70.177 211.381 100.793C217.623 131.409 250.074 155.004 283.861 153.495Z",
    stroke: "#3F97FF",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M267.708 180.911C313.589 175.974 342.619 137.162 332.548 94.2237C322.477 51.2852 277.119 20.4795 231.238 25.4173C185.357 30.3551 156.327 69.1665 166.397 112.105C176.468 155.043 221.826 185.849 267.708 180.911Z",
    stroke: "#3F97FF",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M253.994 211.21C311.393 201.17 346.109 148.28 331.536 93.0756C316.962 37.8713 258.618 1.25783 201.219 11.2971C143.82 21.3364 109.104 74.2268 123.677 129.431C138.25 184.635 196.595 221.249 253.994 211.21Z",
    stroke: "#3F97FF",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M242.908 243.922C311.287 227.079 350.759 158.918 331.07 91.6786C311.382 24.4394 239.99 -16.4152 171.611 0.427252C103.232 17.2697 63.7606 85.4313 83.4488 152.671C103.137 219.91 174.529 260.764 242.908 243.922Z",
    stroke: "#3F97FF",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M234.633 278.548C313.499 253.189 356.874 168.698 331.515 89.8322C306.156 10.9663 221.665 -32.4096 142.799 -7.05054C63.9335 18.3085 20.5576 102.8 45.9166 181.665C71.2757 260.531 155.767 303.907 234.633 278.548Z",
    stroke: "#3F97FF",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurServiceRightBg);
export default __webpack_public_path__ + "static/media/ourServiceRightBg.9b545e78729315db82f5cfd8de3432e8.svg";
export { ForwardRef as ReactComponent };